import type { ReactNode } from "react";
import { Box, Paper } from "@mui/material";
export function MainContainer({
  children,
  paperless = false,
}: {
  children: ReactNode;
  paperless?: boolean;
}) {
  return (
    <Box
      sx={{ flex: 1, minHeight: 0, overflow: "auto", background: "#eee", p: 2 }}
    >
      {paperless ? children : <Paper>{children}</Paper>}
    </Box>
  );
}
